var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('div',{staticClass:"jxyxjy2023"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('div',{staticClass:"btn",on:{"click":_vm.toThirdParty}},[_vm._v("免费咨询")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }